var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 617,
    height: 623,
    viewBox: "0 0 617 623",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420.848 491.387H414.618V517.886H420.848V491.387Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M421.937 491.387V498.638H426.806V510.622H421.937V517.886H434.193V491.387H421.937Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M425.079 499.737H414.618V509.531H425.079V499.737Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M440.423 491.387H434.193V517.886H440.423V491.387Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M441.511 491.387V498.638H446.395V510.622H441.511V517.886H453.781V491.387H441.511Z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M444.654 499.737H434.193V509.531H444.654V499.737Z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M460.011 491.387H453.781V517.886H460.011V491.387Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M461.1 491.387V498.638H465.969V510.622H461.1V517.886H473.369V491.387H461.1Z",
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M464.242 499.737H453.781V509.531H464.242V499.737Z",
    fill: "#263238"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M479.599 491.387H473.369V517.886H479.599V491.387Z",
    fill: "#263238"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M480.688 491.387V498.638H485.558V510.622H480.688V517.886H492.944V491.387H480.688Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M483.83 499.737H473.369V509.531H483.83V499.737Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M499.174 491.387H492.944V517.886H499.174V491.387Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M500.262 491.387V498.638H505.132V510.622H500.262V517.886H512.532V491.387H500.262Z",
    fill: "#263238"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M503.405 499.737H492.944V509.531H503.405V499.737Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M518.762 491.387H512.532V517.886H518.762V491.387Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M519.851 491.387V498.638H524.72V510.622H519.851V517.886H532.12V491.387H519.851Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M522.993 499.737H512.532V509.531H522.993V499.737Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M538.337 491.387H532.107V517.886H538.337V491.387Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M539.425 491.387V498.638H544.309V510.622H539.425V517.886H551.695V491.387H539.425Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M542.568 499.737H532.107V509.531H542.568V499.737Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M559.626 517.434C558.215 517.64 556.793 517.758 555.368 517.787L553.26 517.883H551.695V491.384H553.26L554.253 491.316C554.905 491.317 555.555 491.262 556.198 491.153L559.626 517.434Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M556.864 491.061L558.021 498.216C559.354 498.011 560.672 497.716 561.965 497.331L565.502 508.799C563.675 509.33 561.817 509.748 559.939 510.05L561.095 517.219C566.659 516.329 572.029 514.488 576.969 511.778L564.06 488.653C561.813 489.851 559.38 490.665 556.864 491.061Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M563.271 508.24C561.347 508.727 559.393 509.086 557.422 509.315C555.477 509.424 553.341 509.573 551.695 509.533V499.738C553.545 499.738 554.878 499.63 556.429 499.575C557.919 499.399 559.396 499.127 560.85 498.759L563.271 508.24Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M584.043 506.936C582.914 507.807 581.772 508.664 580.615 509.493C579.459 510.323 578.194 511.003 576.97 511.738L564.061 488.613L565.734 487.593C566.251 487.198 566.768 486.804 567.298 486.423L584.043 506.936Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M567.801 485.944L572.562 491.385L574.058 490.025L575.418 488.529L584.424 496.418C583.784 497.126 583.159 497.779 582.506 498.527L580.397 500.445L585.158 505.886C589.419 502.213 593.001 497.821 595.741 492.909L572.616 479.932C571.39 482.212 569.758 484.25 567.801 485.944Z",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M582.288 497.197C579.516 500.039 576.356 502.475 572.902 504.433L568.127 495.877C570.746 494.406 573.146 492.574 575.255 490.436L582.288 497.197Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M599.265 485.169C598.33 487.875 597.156 490.493 595.755 492.99L572.63 480.013C573.252 478.875 573.78 477.687 574.208 476.463L599.265 485.169Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M574.467 475.837L581.391 478.013L581.908 476.054L582.152 475.075L582.302 474.068L594.123 476.041L593.905 477.401L593.565 478.761C593.321 479.673 593.089 480.598 592.831 481.482L599.755 483.645C600.149 482.284 600.489 480.924 600.829 479.564C601.169 478.203 601.319 476.843 601.537 475.415C601.75 474.028 601.868 472.628 601.89 471.225L601.986 469.13V467.675H575.487V469.185L575.419 470.151C575.424 470.793 575.374 471.435 575.269 472.069C575.133 472.694 575.12 473.347 574.943 473.959C574.766 474.571 574.63 475.224 574.467 475.837Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M592.695 477.796C591.821 481.677 590.402 485.414 588.478 488.896L579.935 484.108C581.388 481.475 582.459 478.649 583.118 475.715L592.695 477.796Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M601.985 461.458H575.487V467.688H601.985V461.458Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M575.487 460.387H582.737V455.517H594.735V460.387H601.985V448.117H575.487V460.387Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M593.633 457.241H583.839V467.702H593.633V457.241Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M601.768 440.701C601.863 442.062 601.931 443.544 601.985 444.959V448.115H575.487V445.041C575.487 444.388 575.392 443.68 575.378 443.068L601.768 440.701Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M575.324 442.402L582.533 441.532L582.22 439.532C582.139 438.865 581.908 438.172 581.758 437.56L593.348 434.499C593.565 435.424 593.865 436.335 594.001 437.219L594.436 440.035L601.632 439.165C600.986 433.561 599.336 428.119 596.762 423.1L573.106 435.07C574.296 437.355 575.048 439.841 575.324 442.402Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M592.749 436.688C592.953 437.667 593.062 438.647 593.225 439.626C593.225 440.116 593.388 440.606 593.429 441.109L593.511 442.592C593.511 443.557 593.633 444.619 593.633 445.503V448.114H583.839V445.503C583.839 444.646 583.771 443.966 583.744 443.19V442.061C583.744 441.694 583.635 441.327 583.581 440.946C583.445 440.211 583.377 439.463 583.213 438.728L592.749 436.688Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M592.218 415.905L593.483 417.619C593.905 418.204 594.245 418.829 594.626 419.428C595.402 420.627 596.106 421.872 596.734 423.155L573.079 435.126C572.807 434.535 572.489 433.966 572.127 433.425C571.95 433.153 571.814 432.854 571.623 432.596L571.025 431.82L592.218 415.905Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M570.631 431.276L576.289 426.732C575.862 426.202 575.408 425.693 574.929 425.209C574.517 424.691 574.062 424.209 573.569 423.767L581.826 415.075C582.532 415.706 583.195 416.383 583.812 417.102C584.469 417.786 585.091 418.503 585.676 419.251L591.348 414.721C587.828 410.338 583.581 406.593 578.792 403.648L564.904 426.215C567.085 427.566 569.022 429.277 570.631 431.276Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M582.438 417.25C585.177 420.12 587.47 423.385 589.24 426.935L580.506 431.343C579.156 428.653 577.409 426.181 575.324 424.011L582.438 417.25Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M571.107 399.812C572.445 400.317 573.753 400.898 575.024 401.553C576.312 402.177 577.561 402.876 578.765 403.648L564.876 426.215C564.338 425.851 563.769 425.532 563.176 425.263C562.607 424.956 562.016 424.692 561.408 424.474L571.107 399.812Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M560.768 424.244L563.217 417.443C561.952 416.978 560.657 416.601 559.34 416.314L561.789 404.574C563.634 404.985 565.451 405.512 567.23 406.152L569.678 399.351C564.389 397.468 558.819 396.493 553.205 396.467V422.965C555.779 422.972 558.335 423.404 560.768 424.244Z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M563.476 406.108C567.333 407.053 571.009 408.625 574.358 410.761L569.23 419.099C567.95 418.308 566.618 417.604 565.244 416.991C563.852 416.442 562.425 415.988 560.973 415.63L563.476 406.108Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M549.356 396.029C549.995 396.097 550.634 396.26 551.287 396.301C551.94 396.342 552.647 396.301 553.246 396.41V422.908C551.886 422.908 550.403 422.786 548.988 422.691C547.574 422.595 546.159 422.323 544.744 422.119L549.356 396.029Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M543.234 421.848L544.717 414.747C542.87 414.343 541.053 413.816 539.276 413.17L543.357 401.893C544.624 402.351 545.919 402.728 547.234 403.022L548.73 395.921C546.227 395.385 543.837 394.413 541.67 393.051L527.713 415.577C532.482 418.556 537.735 420.678 543.234 421.848Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M544.35 403.431C547.24 404.266 550.225 404.723 553.233 404.792V414.572C549.258 414.521 545.309 413.931 541.493 412.817L544.35 403.431Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M538.514 390.71L539.235 391.377L540.024 391.948L540.799 392.547C541.058 392.737 541.357 392.887 541.629 393.05L527.713 415.576C527.101 415.196 526.489 414.842 525.904 414.434L524.177 413.155L522.476 411.863C521.932 411.414 521.402 410.924 520.871 410.502L538.514 390.71Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M519.728 409.442L524.734 404.191C524.028 403.555 523.365 402.873 522.748 402.15C522.084 401.472 521.462 400.755 520.885 400.001L530.271 392.533C530.69 393.07 531.145 393.579 531.631 394.057C532.046 394.576 532.501 395.062 532.991 395.512L537.997 390.261C536.145 388.485 534.608 386.405 533.454 384.113L509.757 395.975C512.279 401.005 515.653 405.561 519.728 409.442Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M530.434 394.356C532.393 396.623 534.686 398.577 537.235 400.151L532.08 408.476C528.692 406.398 525.642 403.816 523.034 400.818L530.434 394.356Z",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M532.026 380.507C532.403 381.747 532.886 382.953 533.468 384.111L509.771 395.973C508.491 393.417 507.435 390.754 506.615 388.015L532.026 380.507Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M506.234 386.575L513.253 384.739C512.991 383.843 512.773 382.935 512.601 382.018L512.179 379.189L524.081 377.828L524.381 379.842C524.462 380.508 524.707 381.202 524.843 381.8L531.862 379.964C531.678 379.354 531.542 378.731 531.454 378.1C531.338 377.471 531.257 376.835 531.209 376.196C531.209 375.53 531.141 374.945 531.101 374.224V371.095H504.588V374.156C504.588 375.516 504.697 376.876 504.779 378.318C504.86 379.76 505.133 381.107 505.323 382.494C505.539 383.873 505.844 385.236 506.234 386.575Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M523.211 379.325C523.687 382.297 524.628 385.175 525.999 387.854L517.239 392.234C515.439 388.687 514.196 384.883 513.553 380.958L523.211 379.325Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M531.1 364.825H504.602V371.055H531.1V364.825Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M504.602 363.736H511.852V358.867H523.85V363.736H531.1V351.467H504.602V363.736Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M522.748 360.595H512.954V371.056H522.748V360.595Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M531.1 345.237H504.602V351.467H531.1V345.237Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M504.602 344.161H511.852V339.278H523.85V344.161H531.1V331.891H504.602V344.161Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M522.748 341.006H512.954V351.467H522.748V341.006Z",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M516.477 325.689L489.639 297.476V258.245",
    stroke: "#263238",
    strokeWidth: 10.1947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M518.368 325.689L545.207 297.476V258.245",
    stroke: "#263238",
    strokeWidth: 10.1947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M522.427 346.032C533.307 344.274 540.702 334.029 538.943 323.149C537.185 312.269 526.94 304.874 516.06 306.633C505.18 308.391 497.785 318.636 499.544 329.516C501.302 340.396 511.547 347.791 522.427 346.032Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M529.815 330.773C532.257 324.913 529.486 318.184 523.626 315.742C517.766 313.301 511.036 316.072 508.595 321.931C506.153 327.791 508.924 334.521 514.784 336.963C520.644 339.404 527.374 336.633 529.815 330.773Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M244.105 486.569H237.861V513.067H244.105V486.569Z",
    fill: "#263238"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M236.787 513.067V505.803H231.89V493.819H236.787V486.569H224.49V513.067H236.787Z",
    fill: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M244.119 494.923H233.631V504.717H244.119V494.923Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M219.688 486.299C220.463 486.408 221.265 486.38 222.054 486.448H223.224H223.823H224.489V512.947H223.592H222.626L220.681 512.852C219.388 512.77 218.096 512.757 216.804 512.593L219.688 486.299Z",
    fill: "#263238"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M215.471 512.443L216.409 505.261L213.689 504.839C212.77 504.738 211.86 504.566 210.968 504.322L213.594 492.624C214.293 492.819 215.007 492.96 215.729 493.046L217.865 493.372L218.803 486.176C217.274 485.996 215.76 485.705 214.274 485.306L212.029 484.748L209.866 483.932L200.535 508.743L204.139 510.036L207.853 511.015C210.355 511.671 212.901 512.149 215.471 512.443Z",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M214.981 494.025C216.545 494.229 218.11 494.555 219.688 494.691L224.489 494.922V504.717C222.639 504.717 220.694 504.54 218.803 504.445C216.913 504.349 215.035 503.914 213.145 503.642L214.981 494.025Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M205.649 482.042C207.034 482.796 208.471 483.45 209.948 484.001L200.616 508.813C198.174 507.918 195.793 506.864 193.488 505.657L205.649 482.042Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M192.278 504.991L195.733 498.611L191.094 495.795L197.746 485.824L201.446 488.082L204.915 481.703L202.942 480.492C202.266 480.12 201.616 479.701 200.997 479.24C199.729 478.354 198.52 477.387 197.379 476.343L179.79 496.163C181.69 497.87 183.689 499.464 185.775 500.937C186.814 501.694 187.89 502.398 188.999 503.046L192.278 504.991Z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M198.521 487.551L200.548 488.789C201.228 489.224 201.909 489.496 202.684 489.864L204.82 490.897C205.541 491.251 206.302 491.469 207.05 491.754L203.595 500.923C202.711 500.569 201.786 500.297 200.875 499.889L198.304 498.651C197.447 498.216 196.549 497.862 195.746 497.359L193.298 495.876L198.521 487.551Z",
    fill: "#263238"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M194.046 473.02L195.624 474.761L197.379 476.339L179.79 496.159L176.92 493.52C176.022 492.581 175.152 491.615 174.281 490.663L194.046 473.02Z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M173.37 489.67L178.879 484.95C178.264 484.284 177.691 483.58 177.165 482.842L175.546 480.665L185.313 473.714L186.673 475.455C187.081 476.053 187.536 476.617 188.034 477.142L193.543 472.422C193.014 471.854 192.532 471.245 192.101 470.599L190.741 468.763L189.544 466.777C189.116 466.133 188.734 465.461 188.401 464.763L164.895 477.006C165.469 478.148 166.1 479.26 166.786 480.339L168.799 483.617L171.084 486.691C171.789 487.727 172.552 488.722 173.37 489.67Z",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M185.368 475.622C185.857 476.248 186.279 476.982 186.823 477.499L188.428 479.267C188.941 479.873 189.486 480.449 190.061 480.995L191.829 482.6L185.327 489.919L183.218 488.001C182.498 487.375 181.858 486.64 181.246 485.919L179.328 483.811C178.675 483.103 178.158 482.301 177.573 481.553L185.368 475.622Z",
    fill: "#263238"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M186.401 460.48C186.941 461.949 187.577 463.381 188.306 464.765L164.8 477.008C163.6 474.703 162.541 472.327 161.63 469.893L186.401 460.48Z",
    fill: "#263238"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M161.168 468.629L167.97 466.181C167.657 465.324 167.317 464.48 167.058 463.623L166.378 460.984L177.995 458.005L178.525 460.114C178.729 460.807 179.015 461.474 179.246 462.154L186.048 459.719C185.002 456.817 184.29 453.805 183.926 450.741L157.713 453.72C158.291 458.806 159.45 463.808 161.168 468.629Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M177.355 459.812C177.547 460.581 177.792 461.336 178.09 462.07L178.906 464.301C179.173 465.047 179.491 465.775 179.858 466.477L180.892 468.627L172.213 473.116L170.975 470.531C170.532 469.688 170.145 468.815 169.819 467.919L168.84 465.199C168.484 464.313 168.189 463.404 167.956 462.478L177.355 459.812Z",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M183.721 445.993L183.857 448.388C183.925 449.163 183.857 449.965 184.007 450.741L157.712 453.72C157.427 451.149 157.372 448.51 157.25 445.993H183.721Z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M157.223 444.906H164.487V440.023H176.471V444.906H183.735V438.758L183.722 435.656L183.545 431.834L157.087 433.398L157.223 435.711V438.758V444.906Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M175.397 441.751V444.376C175.397 445.247 175.397 446.158 175.397 446.92C175.519 448.511 175.506 450.103 175.696 451.681L165.97 452.783C165.739 450.892 165.725 448.974 165.616 447.07C165.616 446.09 165.616 445.26 165.616 444.349V441.724L175.397 441.751Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M182.647 424.148C183.122 426.7 183.422 429.282 183.545 431.875L157.087 433.439C157.027 431.868 156.85 430.304 156.557 428.76L182.647 424.148Z",
    fill: "#263238"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M156.448 427.914L163.562 426.554C163.263 425.194 162.841 423.752 162.515 422.351L174.009 418.964C174.444 420.719 174.948 422.46 175.369 424.228L182.497 422.868C182.252 421.616 181.899 420.378 181.586 419.141C181.273 417.903 180.987 416.651 180.566 415.441L179.205 411.836L178.525 410.027C178.294 409.442 177.995 408.87 177.723 408.285L153.632 419.141C153.795 419.494 153.986 419.834 154.135 420.188L154.516 421.276L155.319 423.439C155.591 424.16 155.713 424.935 155.917 425.67C156.121 426.405 156.352 427.153 156.448 427.914Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M173.424 421.046L174.132 423.767C174.322 424.706 174.444 425.644 174.594 426.596L175.016 429.426C175.138 430.364 175.138 431.317 175.206 432.269L165.426 432.854C165.426 432.051 165.426 431.262 165.29 430.473L164.922 428.229C164.786 427.44 164.705 426.651 164.555 425.875L163.957 423.563L173.424 421.046Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M174.036 401.307C174.676 402.436 175.397 403.497 175.982 404.681L177.668 408.19L153.632 419.141L152.625 417.032C152.265 416.333 151.87 415.652 151.442 414.992L174.036 401.307Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M150.979 414.3L157.114 410.423C156.362 409.187 155.531 408.001 154.625 406.873L164.147 399.582C165.275 400.996 166.311 402.482 167.248 404.03L173.383 400.153L172.377 398.521C172.023 397.99 171.628 397.487 171.247 396.97L168.962 393.909C168.214 392.876 167.289 391.978 166.446 391.026C165.602 390.073 164.745 389.108 163.834 388.223L145.211 407.063C145.756 407.608 146.245 408.22 146.776 408.777C147.32 409.325 147.829 409.907 148.299 410.519L149.66 412.382C149.891 412.695 150.136 412.981 150.353 413.307L150.979 414.3Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M164.405 401.754C166.63 404.855 168.543 408.168 170.119 411.644L161.209 415.725C159.892 412.829 158.298 410.069 156.448 407.481L164.405 401.754Z",
    fill: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M157.971 383.108C158.488 383.503 159.018 383.884 159.522 384.292L160.964 385.652L163.834 388.278L145.211 407.118L143.457 405.54L142.586 404.737C142.287 404.492 141.96 404.275 141.647 404.03L157.971 383.108Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M140.995 403.499L145.348 397.691L143.607 396.33C143.008 395.922 142.382 395.569 141.77 395.188L148.055 384.985C148.83 385.462 149.619 385.91 150.367 386.427L152.544 388.046L156.897 382.238C155.863 381.489 154.87 380.687 153.795 379.993L150.531 377.994L148.885 377.014C148.327 376.701 147.742 376.443 147.171 376.157L143.702 374.498L133.037 398.752L135.118 399.758C135.458 399.935 135.826 400.071 136.166 400.262L137.145 400.874L139.131 402.071C139.784 402.533 140.369 403.05 140.995 403.499Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M149.102 386.958C150.68 388.019 152.176 389.216 153.7 390.345C155.223 391.474 156.543 392.889 157.971 394.167L151.088 401.118C149.891 400.071 148.748 398.956 147.538 397.949C146.327 396.942 145.007 396.004 143.688 395.12L149.102 386.958Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M136.397 371.816C137.648 372.197 138.859 372.673 140.083 373.176C141.313 373.595 142.521 374.076 143.702 374.618L133.037 398.872C132.33 398.535 131.597 398.253 130.847 398.029C130.112 397.771 129.391 397.458 128.643 397.226L136.397 371.816Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M127.854 396.942L129.84 389.964L127.732 389.433C127.042 389.22 126.337 389.061 125.623 388.957L127.827 377.177C128.746 377.309 129.655 377.504 130.547 377.762L133.186 378.429L135.159 371.45C132.705 370.733 130.205 370.183 127.677 369.804L123.882 369.233C122.617 369.124 121.338 369.083 120.073 369.015L118.808 395.487C119.583 395.487 120.359 395.487 121.134 395.596L123.42 395.963C124.919 396.184 126.401 396.511 127.854 396.942Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M129.473 378.644C131.323 379.147 133.2 379.528 134.996 380.154C136.792 380.779 138.614 381.392 140.342 382.194L136.397 391.159C135.037 390.478 133.432 390.043 131.963 389.458C130.493 388.873 128.888 388.642 127.365 388.207L129.473 378.644Z",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M112.728 368.96L114.673 368.878H116.251C116.713 368.878 117.421 368.878 118.06 368.878L120.005 368.973L118.74 395.445L117.557 395.377C117.104 395.35 116.649 395.35 116.196 395.377H114.646L113.462 395.458L112.728 368.96Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M112.7 395.5L112.347 388.25L110.17 388.358C109.449 388.358 108.81 388.562 108.021 388.658L106.348 376.782C107.246 376.66 108.13 376.483 109.068 376.415L111.789 376.279L111.422 369.029C110.157 369.11 108.878 369.137 107.613 369.273L103.818 369.845C101.29 370.235 98.791 370.789 96.3359 371.504L103.586 396.942C105.061 396.503 106.566 396.171 108.089 395.949L110.374 395.582C111.15 395.582 111.925 395.582 112.7 395.5Z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M108.375 377.598C110.265 377.421 112.17 377.366 114.074 377.271C115.054 377.203 115.856 377.271 116.795 377.271L119.638 377.407L119.175 387.188L116.795 387.065C115.938 387.065 114.986 387.065 114.224 387.065C112.632 387.174 111.041 387.201 109.463 387.337L108.375 377.598Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9224 374.046L92.5816 372.686C93.7917 372.205 95.0323 371.805 96.2952 371.489L103.586 396.94C102.824 397.118 102.078 397.36 101.355 397.661L99.1518 398.463L88.9224 374.046Z",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4176 398.844L95.4793 392.206C94.119 392.859 92.8403 393.417 91.5889 394.124L85.7532 383.65C87.3311 382.766 89.0043 382.045 90.6231 381.242L87.6984 374.604C85.3608 375.637 83.0893 376.814 80.8969 378.127L77.6186 380.127C76.5576 380.834 75.5646 381.623 74.5308 382.385L90.4734 403.537C91.0992 403.088 91.6977 402.585 92.337 402.177L94.3231 400.98C95.6431 400.185 97.0105 399.472 98.4176 398.844Z",
    fill: "#263238"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9702 383.745C91.3672 382 94.9251 380.588 98.5941 379.529L101.315 388.942C98.2429 389.822 95.2635 390.997 92.4184 392.451L87.9702 383.745Z",
    fill: "#263238"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5723 387.42L71.4561 384.795C72.3947 383.897 73.4965 383.203 74.5168 382.4L90.4594 403.553C89.8163 404.004 89.1987 404.489 88.6094 405.009L86.8682 406.6L68.5723 387.42Z",
    fill: "#263238"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2566 407.116L81.1419 401.974L78.2037 405.17L69.0217 397.471C70.2459 396.111 71.443 394.751 72.6945 393.458L67.5798 388.316C66.6956 389.228 65.8522 390.18 64.9816 391.119C64.1009 392.04 63.27 393.007 62.4923 394.016C60.8953 396.012 59.419 398.101 58.0713 400.273L80.5162 414.366C81.3444 413.051 82.253 411.788 83.2368 410.584C83.704 409.97 84.2131 409.388 84.7603 408.843C85.2228 408.272 85.7125 407.673 86.2566 407.116Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1436 396.777L73.0616 394.655C73.7281 393.975 74.4219 393.363 75.1564 392.71L77.2785 390.792C77.9995 390.18 78.7884 389.636 79.5502 389.051L85.4403 396.94C84.8009 397.417 84.08 397.865 83.5359 398.382L81.7811 399.988C81.1961 400.532 80.5704 401.035 80.0263 401.606L78.4347 403.375L71.1436 396.777Z",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3301 407.101C54.915 405.931 55.4455 404.747 56.0713 403.605L58.0845 400.272L80.5294 414.365L79.2915 416.378C78.9242 417.058 78.6114 417.738 78.2713 418.486L54.3301 407.101Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8906 419.221L71.2795 416.242L70.8034 417.208L70.4362 418.228L69.688 420.269L58.4112 416.365L59.3498 413.807L59.8259 412.529L60.4108 411.304L53.7997 408.325C53.2371 409.472 52.7464 410.654 52.3306 411.862L50.9703 415.48C50.5622 416.691 50.2902 417.943 49.9501 419.18C49.61 420.418 49.2836 421.656 49.0659 422.908L75.0748 427.995C75.1836 427.233 75.4557 426.499 75.6189 425.751C75.7821 425.002 75.9726 424.254 76.2174 423.52L77.02 421.357C77.2476 420.621 77.5389 419.906 77.8906 419.221Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0435 414.939C60.7028 413.148 61.4705 411.4 62.3424 409.702C63.1886 407.981 64.1474 406.318 65.2126 404.723L73.3744 409.933C72.5093 411.264 71.7323 412.65 71.0483 414.082C70.3112 415.486 69.6747 416.941 69.1438 418.435L60.0435 414.939Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0454 430.636C48.0454 429.983 48.0454 429.275 48.1814 428.69L48.4671 426.759L49.0656 422.909L75.0745 427.997L74.7344 430.323L74.544 431.479C74.5237 431.873 74.5237 432.268 74.544 432.663L48.0454 430.636Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4354 433.477L67.185 433.069C67.185 434.511 67.0082 435.898 67.049 437.612H55.0512C55.0512 436.061 55.1328 434.184 55.2144 432.388L47.9776 431.967L47.8008 435.789V445.026H74.2993V435.803L74.4354 433.477Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1528 435.874L56.4385 430.174C56.6562 428.284 56.9826 426.406 57.2683 424.516L66.872 426.393C66.6543 427.971 66.3687 429.535 66.1782 431.113L65.947 435.874H56.1528Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2993 445.029H47.8008V451.273H74.2993V445.029Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2993 452.361H67.049V457.244H55.0512V452.361H47.8008V464.658H74.2993V452.361Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M65.947 445.029H56.1528V455.517H65.947V445.029Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2993 464.657H47.8008V470.901H74.2993V464.657Z",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2993 471.989H67.049V476.872H55.0512V471.989H47.8008V484.286H74.2993V471.989Z",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M65.947 464.657H56.1528V475.145H65.947V464.657Z",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2993 484.286H47.8008V490.529H74.2993V484.286Z",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M65.947 484.286H56.1528V494.774H65.947V484.286Z",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2993 490.529H67.049V495.426H55.0512V490.529H47.8008V502.826H74.2993V490.529Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M65.947 483.197H56.1528V493.685H65.947V483.197Z",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4917 500.772L91.3303 528.985V568.216",
    stroke: "#263238",
    strokeWidth: 10.1947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6008 500.772L35.7485 528.985V568.216",
    stroke: "#263238",
    strokeWidth: 10.1947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9641 519.767C75.8428 518.001 83.2303 507.751 81.4644 496.872C79.6986 485.993 69.4481 478.606 58.5693 480.371C47.6906 482.137 40.3031 492.388 42.069 503.267C43.8348 514.145 54.0853 521.533 64.9641 519.767Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7438 510.948C67.7464 510.948 72.6125 506.082 72.6125 500.079C72.6125 494.077 67.7464 489.21 61.7438 489.21C55.7411 489.21 50.875 494.077 50.875 500.079C50.875 506.082 55.7411 510.948 61.7438 510.948Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M180.158 219.053C185.926 220.554 191.887 221.182 197.842 220.916L197.42 215.856C197.121 215.856 167.493 217.964 144.64 190.69L140.75 193.955C150.849 206.337 164.667 215.137 180.158 219.053Z",
    fill: "#263238"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M140.274 248.514C170.976 221.05 196.046 229.864 196.304 229.96L198.059 225.199C196.93 224.777 169.833 215.255 136.846 244.732L140.274 248.514Z",
    fill: "#263238"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M140.247 273.233C171.683 271.438 198.835 236.845 199.977 235.363L195.978 232.261C195.706 232.601 169.071 266.5 139.961 268.173L140.247 273.233Z",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M143.647 193.953L137.05 186.757",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M141.852 242.775L134.017 252.011",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M144.912 270.024C140.495 270.064 136.087 269.607 131.772 268.664",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M126.453 250.611L118.686 251.958",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M130.194 254.323L120.481 263.546",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M134.03 255.726L133.622 263.058",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M128.154 205.938L111.055 201.735",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M141.076 210.062L114.809 211.028",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M134.139 198.594L118.903 192.513",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M177.301 266.841L169.792 278.472",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M171.819 264.567L154.598 281.706",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M170.35 251.646L157.549 252.68",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M106.674 229.009L109.572 234.287L105.45 238.681L111.367 237.538L114.265 242.816L115.013 236.844L120.93 235.715L115.489 233.158L116.237 227.186L112.116 231.58L106.674 229.009Z",
    fill: "#CC0033",
    stroke: "#263238",
    strokeWidth: 0.566373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 169.659L117.666 174.924L113.544 179.317L119.461 178.188L122.359 183.466L123.12 177.495L129.024 176.352L123.583 173.795L124.331 167.823L120.209 172.217L114.768 169.659Z",
    fill: "#CC0033",
    stroke: "#263238",
    strokeWidth: 0.566373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M437.607 468.64C432.065 469.13 426.63 470.46 421.488 472.584L423.46 476.897C423.719 476.774 449.088 465.579 477.872 482.338L480.253 478.257C467.445 470.539 452.487 467.166 437.607 468.64Z",
    fill: "#263238"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M463.371 430.103C445.048 463.974 420.182 464.11 419.951 464.11V468.844C421.093 468.844 447.946 468.667 467.561 432.32L463.371 430.103Z",
    fill: "#263238"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M455.618 408.35C428.52 419.872 415.57 458.899 415.026 460.545L419.543 462.014C419.665 461.633 432.384 423.382 457.468 412.717L455.618 408.35Z",
    fill: "#263238"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M477.654 479.169L485.734 483.427",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M463.793 435.651L467.779 425.054",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M452.489 412.652C456.365 411.221 460.389 410.231 464.487 409.7",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M474.866 423.885L481.273 420.253",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M470.417 421.806L476.036 410.625",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M466.595 421.779L464.636 415.209",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M487.503 463.728L503.867 462.014",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M474.825 464.191L497.623 455.036",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M484.551 472.094L499.881 472.611",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M424.997 425.695L427.935 413.085",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M430.547 425.966L440.287 405.439",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M435.92 436.85L446.857 431.899",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M499.106 436.643L494.889 432.916L497.12 427.747L492.278 430.617L488.061 426.89L489.285 432.386L484.442 435.242L490.047 435.773L491.271 441.268L493.502 436.113L499.106 436.643Z",
    fill: "#CC0033",
    stroke: "#263238",
    strokeWidth: 0.566373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M510.75 491.422L506.533 487.695L508.764 482.526L503.922 485.396L499.705 481.669L500.929 487.165L496.086 490.035L501.691 490.552L502.915 496.047L505.146 490.892L510.75 491.422Z",
    fill: "#CC0033",
    stroke: "#263238",
    strokeWidth: 0.566373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M439.389 400.855L435.159 397.142L437.403 391.973L432.56 394.843L428.33 391.116L429.568 396.611L424.725 399.468L430.316 399.998L431.554 405.494L433.785 400.339L439.389 400.855Z",
    fill: "#CC0033",
    stroke: "#263238",
    strokeWidth: 0.566373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M156.502 342.266V345.776",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M156.502 303.797V339.083",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M150.625 315.686V350.523",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M465.588 304.845V310.055",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M465.588 247.713V300.125",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M459.698 265.359V317.118",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M385.549 383.213H380.339",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M442.681 383.213H390.269",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M425.038 377.324H373.279",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M204.017 383.213H198.793",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M261.15 383.213H208.737",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M243.507 377.324H191.734",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M336.143 361.474H280.071V417.546H336.143V361.474Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M336.143 361.474H280.071V376.274H336.143V361.474Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M280.765 387.687H335.667",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M280.765 398.421H335.667",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M280.765 409.169H335.667",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M332.116 374.806V385.158",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M332.116 387.864V395.508",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M332.116 398.952V406.597",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M272.93 151.5H343.271C346.207 151.5 349.024 152.667 351.1 154.743C353.177 156.82 354.343 159.636 354.343 162.573V189.303H261.843V162.573C261.843 159.636 263.01 156.82 265.086 154.743C267.163 152.667 269.979 151.5 272.916 151.5H272.93Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M446.68 164.668H169.534C166.709 164.668 164.419 166.958 164.419 169.783V364.632C164.419 367.456 166.709 369.746 169.534 369.746H446.68C449.505 369.746 451.795 367.456 451.795 364.632V169.783C451.795 166.958 449.505 164.668 446.68 164.668Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M436.07 174.164H180.117C177.292 174.164 175.002 176.454 175.002 179.279V355.138C175.002 357.962 177.292 360.252 180.117 360.252H436.07C438.895 360.252 441.185 357.962 441.185 355.138V179.279C441.185 176.454 438.895 174.164 436.07 174.164Z",
    fill: "#CC0033",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M344.903 158.357C344.901 157.679 344.697 157.018 344.319 156.456C343.941 155.894 343.404 155.457 342.778 155.199C342.151 154.942 341.462 154.876 340.798 155.01C340.134 155.144 339.525 155.471 339.047 155.951C338.569 156.431 338.243 157.042 338.112 157.707C337.981 158.371 338.05 159.06 338.31 159.685C338.569 160.311 339.009 160.845 339.572 161.221C340.136 161.598 340.798 161.798 341.475 161.798C341.927 161.798 342.373 161.709 342.79 161.536C343.207 161.363 343.586 161.109 343.904 160.789C344.223 160.47 344.475 160.09 344.646 159.673C344.818 159.255 344.905 158.808 344.903 158.357Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M332.034 158.358C332.034 157.676 331.832 157.01 331.453 156.444C331.075 155.878 330.536 155.437 329.907 155.177C329.277 154.917 328.584 154.849 327.917 154.983C327.249 155.117 326.635 155.446 326.155 155.929C325.674 156.412 325.347 157.026 325.216 157.694C325.085 158.363 325.155 159.055 325.417 159.684C325.68 160.313 326.123 160.849 326.691 161.226C327.259 161.602 327.925 161.802 328.607 161.799C329.058 161.799 329.505 161.71 329.922 161.537C330.338 161.364 330.717 161.11 331.035 160.79C331.354 160.471 331.606 160.091 331.777 159.674C331.949 159.256 332.036 158.809 332.034 158.358Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M319.166 158.358C319.166 157.676 318.964 157.01 318.585 156.444C318.207 155.878 317.668 155.437 317.039 155.177C316.409 154.917 315.716 154.849 315.048 154.983C314.38 155.117 313.767 155.446 313.286 155.929C312.806 156.412 312.479 157.026 312.348 157.694C312.216 158.363 312.287 159.055 312.549 159.684C312.812 160.313 313.255 160.849 313.823 161.226C314.39 161.602 315.057 161.802 315.738 161.799C316.19 161.799 316.637 161.71 317.053 161.537C317.47 161.364 317.849 161.11 318.167 160.79C318.486 160.471 318.738 160.091 318.909 159.674C319.081 159.256 319.168 158.809 319.166 158.358Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M332.116 410.049V417.694",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3541 576.497H543.86C547.911 576.497 551.797 578.106 554.662 580.971C557.527 583.836 559.136 587.722 559.136 591.773V621.087H57.0508V591.773C57.0508 589.765 57.4468 587.776 58.2162 585.921C58.9856 584.066 60.1133 582.38 61.5347 580.961C62.9561 579.543 64.6433 578.418 66.4998 577.652C68.3564 576.886 70.3457 576.493 72.3541 576.497Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 416.226H404.552C406.558 416.226 408.545 416.621 410.398 417.389C412.252 418.157 413.936 419.282 415.354 420.701C416.773 422.119 417.898 423.803 418.666 425.657C419.433 427.51 419.828 429.496 419.828 431.502V621.087H196.373V431.502C196.373 427.451 197.982 423.565 200.847 420.701C203.712 417.836 207.597 416.226 211.649 416.226Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M376.857 458.926H239.344C236.519 458.926 234.229 461.216 234.229 464.04V557.098C234.229 559.923 236.519 562.213 239.344 562.213H376.857C379.681 562.213 381.971 559.923 381.971 557.098V464.04C381.971 461.216 379.681 458.926 376.857 458.926Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M251.383 576.893C251.383 575.424 250.947 573.988 250.131 572.767C249.315 571.545 248.155 570.593 246.798 570.031C245.441 569.469 243.947 569.322 242.507 569.609C241.066 569.895 239.742 570.603 238.704 571.641C237.665 572.68 236.958 574.003 236.671 575.444C236.384 576.885 236.532 578.378 237.094 579.735C237.656 581.092 238.608 582.252 239.829 583.069C241.051 583.885 242.487 584.32 243.956 584.32C245.925 584.32 247.815 583.538 249.207 582.145C250.6 580.752 251.383 578.863 251.383 576.893Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M269.04 584.32C273.141 584.32 276.467 580.995 276.467 576.893C276.467 572.791 273.141 569.466 269.04 569.466C264.938 569.466 261.612 572.791 261.612 576.893C261.612 580.995 264.938 584.32 269.04 584.32Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M294.109 584.32C298.211 584.32 301.537 580.995 301.537 576.893C301.537 572.791 298.211 569.466 294.109 569.466C290.007 569.466 286.682 572.791 286.682 576.893C286.682 580.995 290.007 584.32 294.109 584.32Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M313.766 583.719V593.935H323.982V583.719H313.766Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M313.766 570.254V580.47H323.982V570.254H313.766Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M326.771 583.719V593.935H336.986V583.719H326.771Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M326.771 570.254V580.47H336.986V570.254H326.771Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M339.775 583.719V593.935H349.991V583.719H339.775Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M339.775 570.254V580.47H349.991V570.254H339.775Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M282.044 447.773H239.33C238.344 447.773 237.398 447.382 236.7 446.686C236.001 445.99 235.607 445.046 235.603 444.06C235.607 443.073 236.001 442.129 236.7 441.433C237.398 440.737 238.344 440.346 239.33 440.346H282.044C283.028 440.346 283.973 440.737 284.669 441.434C285.366 442.13 285.757 443.075 285.757 444.06C285.757 444.547 285.661 445.03 285.474 445.481C285.288 445.931 285.014 446.341 284.669 446.685C284.325 447.03 283.915 447.304 283.465 447.49C283.014 447.677 282.531 447.773 282.044 447.773Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M252.321 450.563C256.423 450.563 259.748 447.238 259.748 443.136C259.748 439.034 256.423 435.709 252.321 435.709C248.219 435.709 244.894 439.034 244.894 443.136C244.894 447.238 248.219 450.563 252.321 450.563Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M419.134 450.412L398.131 471.687V570.948L419.801 592.223",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M197.243 450.412L218.259 471.687V570.948L196.59 592.223",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M237.453 509.95H271.188L292.491 478.187L312.882 509.95H327.763L341.108 529.796L352.575 510.29H373.428",
    stroke: "#CC0033",
    strokeWidth: 2.26549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 621.09H616.214",
    stroke: "#263238",
    strokeWidth: 2.26549,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M181.001 537.797C179.436 535.348 179.804 532.356 181.803 531.064C183.803 529.771 186.687 530.751 188.251 533.199C189.816 535.648 189.435 538.64 187.435 539.933C185.435 541.225 182.552 540.246 181.001 537.797Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M171.465 538.641C171.554 538.58 171.65 538.53 171.751 538.491L182.756 533.567C183.297 533.325 183.912 533.309 184.466 533.52C185.019 533.732 185.466 534.155 185.708 534.696C185.949 535.237 185.966 535.852 185.755 536.406C185.543 536.959 185.12 537.406 184.579 537.648L173.56 542.559C173.045 542.807 172.454 542.848 171.911 542.671C171.367 542.494 170.912 542.114 170.642 541.611C170.372 541.107 170.306 540.518 170.46 539.967C170.613 539.416 170.974 538.946 171.465 538.655V538.641Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8781 281.461C33.3274 279.012 33.6946 276.02 35.6943 274.659C37.6939 273.299 40.5777 274.346 42.1285 276.795C43.6792 279.243 43.3255 282.236 41.3259 283.596C39.3263 284.957 36.4424 283.909 34.8781 281.461Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3423 282.305L25.6416 282.156L36.6463 277.232C37.1875 276.992 37.8018 276.977 38.3541 277.19C38.9064 277.403 39.3515 277.826 39.5914 278.367C39.8313 278.909 39.8464 279.523 39.6334 280.075C39.4204 280.627 38.9967 281.073 38.4555 281.312L27.4507 286.223C26.941 286.433 26.3719 286.446 25.8529 286.261C25.3339 286.075 24.9019 285.705 24.64 285.22C24.3782 284.735 24.3051 284.17 24.4347 283.635C24.5644 283.099 24.8877 282.63 25.3423 282.319V282.305Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M575.079 346.607C574.48 349.45 572.113 351.355 569.801 350.865C567.488 350.375 566.087 347.668 566.686 344.839C567.284 342.01 569.651 340.092 571.964 340.581C574.276 341.071 575.677 343.805 575.079 346.607Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M582.492 352.702L582.179 352.607L570.862 348.431C570.339 348.203 569.924 347.783 569.701 347.259C569.478 346.734 569.465 346.144 569.663 345.61C569.861 345.075 570.257 344.637 570.768 344.385C571.279 344.133 571.868 344.086 572.412 344.255L583.716 348.431C584.235 348.632 584.66 349.02 584.908 349.519C585.155 350.017 585.207 350.59 585.054 351.125C584.901 351.66 584.553 352.119 584.079 352.41C583.605 352.702 583.039 352.806 582.492 352.702Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M503.228 559.834C502.616 562.677 500.249 564.581 497.936 564.091C495.624 563.602 494.223 560.895 494.821 558.065C495.42 555.236 497.787 553.318 500.113 553.808C502.439 554.297 503.786 556.991 503.228 559.834Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M510.587 565.898L510.274 565.803L498.97 561.627C498.457 561.395 498.05 560.976 497.833 560.456C497.615 559.936 497.602 559.353 497.797 558.824C497.992 558.295 498.379 557.86 498.882 557.605C499.385 557.35 499.966 557.295 500.507 557.451L511.825 561.627C512.349 561.826 512.778 562.215 513.029 562.716C513.279 563.218 513.331 563.795 513.175 564.333C513.019 564.872 512.666 565.331 512.187 565.621C511.707 565.911 511.136 566.01 510.587 565.898Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M451.836 547.822L445.619 544.802L439.417 547.822L437.879 554.623L442.178 560.065H449.075L453.373 554.623L451.836 547.822ZM447.374 556.514H443.878L441.688 553.794L442.464 550.338L445.619 548.801L448.775 550.338L449.551 553.794L447.374 556.514Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M557.055 219.175L550.838 216.142L544.622 219.175L543.098 225.977L547.397 231.418H554.28L558.578 225.977L557.055 219.175ZM552.593 227.868H549.083L546.907 225.147L547.682 221.692L550.838 220.1L553.994 221.637L554.77 225.093L552.593 227.868Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M501.283 185.166L495.066 182.133L488.85 185.166L487.326 191.968L491.625 197.409H498.508L502.806 191.968L501.283 185.166ZM496.821 193.859H493.311L491.135 191.138L491.91 187.683L495.066 186.091L498.222 187.628L498.998 191.084L496.821 193.859Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M173.016 602.6L166.8 599.621L160.597 602.654L159.06 609.456L163.358 614.897H170.255L174.54 609.456L173.016 602.6ZM168.595 611.292H165.058L162.868 608.571L163.644 605.116L166.8 603.579L169.956 605.062L170.731 608.517L168.595 611.292Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M118.604 472.011L112.388 469.032L106.185 472.065L104.647 478.867L108.946 484.308H115.843L120.128 478.867L118.604 472.011ZM114.183 480.703H110.646L108.456 477.982L109.232 474.527L112.388 472.99L115.543 474.473L116.319 477.928L114.183 480.703Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6744 301.184L63.4579 298.151L57.2549 301.184L55.7178 307.986L60.0163 313.427H66.913L71.2116 307.986L69.6744 301.184ZM65.2126 309.877H61.7167L59.5266 307.156L60.3156 303.701L63.4579 302.164L66.5729 303.646L67.3891 307.156L65.2126 309.877Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M284.71 391.494L278.507 388.474L272.291 391.494L270.753 398.295L275.052 403.737H281.949L286.247 398.295L284.71 391.494ZM280.248 400.186H276.752L274.576 397.466L275.351 394.011L278.507 392.473L281.663 394.011L282.438 397.466L280.248 400.186Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88281 90H219.756V144.344",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16895 107.156H144.939L165.888 90.0974",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M187.476 90.0977L168.105 66.823H6.02588",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73975 49.6682H129.486L145.932 66.8624",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M135.485 89.8256L124.344 80.562H6.88281",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M224.979 137.952L219.647 145.678L215.117 138.224",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88281 121.668H187.353V144.739",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M192.591 138.345L187.258 146.072L182.729 138.604",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M137.05 57.6682H243.656V145.135",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 138.739L243.547 146.466L239.018 138.998",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M605.087 90H392.214V144.344",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M606.801 107.156H467.03L446.082 90.0974",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M424.494 90.0977L443.864 66.823H605.944",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M604.23 49.6682H482.483L466.037 66.8624",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M476.484 89.8256L487.625 80.562H605.087",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M386.99 137.952L392.323 145.678L396.852 138.224",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M605.087 121.668H424.603V144.739",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M419.379 138.345L424.711 146.072L429.241 138.604",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M474.92 57.6682H368.313V145.135",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M363.09 138.739L368.422 146.466L372.952 138.998",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M306.788 2.45117V144.983",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M323.941 0.73877V84.5738L306.883 105.522",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M306.883 127.125L283.622 107.741V1.59717",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M266.455 3.30957V69.1343L283.662 85.5667",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M306.624 75.1182L297.347 63.9774V2.45117",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M301.55 138.593L306.883 146.32L311.426 138.852",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M338.455 2.45117V144.983",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M333.231 138.593L338.564 146.32L343.094 138.852",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M274.453 76.6858V144.986",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M269.216 138.593L274.562 146.32L279.092 138.852",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M303.988 204.313L232.666 318.128C232.229 318.826 231.999 319.617 232 320.422C232.001 321.227 232.232 322.018 232.67 322.715C233.108 323.412 233.737 323.99 234.495 324.391C235.253 324.792 236.112 325.002 236.986 325H379.631C380.505 325.002 381.364 324.792 382.122 324.391C382.88 323.99 383.509 323.412 383.947 322.715C384.386 322.018 384.616 321.227 384.617 320.422C384.618 319.617 384.388 318.826 383.951 318.128L312.629 204.313C312.194 203.611 311.566 203.027 310.807 202.62C310.048 202.214 309.186 202 308.309 202C307.431 202 306.569 202.214 305.81 202.62C305.051 203.027 304.423 203.611 303.988 204.313Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M303.988 218.054L245.585 311.254C245.148 311.951 244.918 312.743 244.919 313.548C244.92 314.353 245.151 315.144 245.589 315.841C246.027 316.538 246.656 317.116 247.414 317.517C248.172 317.918 249.031 318.128 249.905 318.126H366.711C367.585 318.128 368.444 317.918 369.202 317.517C369.96 317.116 370.589 316.538 371.027 315.841C371.465 315.144 371.696 314.353 371.697 313.548C371.698 312.743 371.468 311.951 371.031 311.254L312.628 218.054C312.194 217.352 311.565 216.767 310.806 216.361C310.048 215.955 309.186 215.741 308.308 215.741C307.43 215.741 306.568 215.955 305.81 216.361C305.051 216.767 304.422 217.352 303.988 218.054Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.13275,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M303.623 270.925V235.59H312.711V270.925L311.529 294.131H304.764L303.623 270.925ZM312.467 300.327V310.766H303.745V300.327H312.467Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a98565213f1a8587b84293e61681180b.svg";
export { ForwardRef as ReactComponent };